import { render, staticRenderFns } from "./hamlet.vue?vue&type=template&id=5bda00d5&scoped=true&"
import script from "./hamlet.vue?vue&type=script&lang=js&"
export * from "./hamlet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bda00d5",
  null
  
)

export default component.exports